function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, forwardRef } from "react";
import { Table, Tag, Row, Col, Image, Alert } from "antd";
import Moment from "react-moment";
import { Container } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CreateInvoice = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var customers = _ref.customers,
    company = _ref.company;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemsAr = _useState2[0],
    setItemsAr = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    amountVa = _useState4[0],
    setAmountVa = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    amountPe = _useState6[0],
    setAmountPe = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    amountPt = _useState8[0],
    setAmountPt = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    amountJour = _useState0[0],
    setAmountJour = _useState0[1];
  var priceVa = 3500000;
  var pricePe = 2800000;
  var pricePt = 2000000;
  var priceJour = 1500000;
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    key: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "P.Unitaire"
    }),
    dataIndex: "price",
    key: "price",
    render: function render(price) {
      return /*#__PURE__*/_jsx("span", {
        children: price.toLocaleString("Fr")
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Qte"
    }),
    dataIndex: "quantity",
    key: "quantity",
    render: function render(qte) {
      return /*#__PURE__*/_jsx("span", {
        children: qte.toLocaleString("Fr")
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Total"
    }),
    dataIndex: "s_total",
    key: "s_total",
    render: function render(t) {
      return /*#__PURE__*/_jsx("span", {
        children: t.toLocaleString("Fr")
      });
    }
  }];
  useEffect(function () {
    customers.forEach(function (c) {
      switch (c.reason) {
        case "0":
          setAmountVa(function (prev) {
            return prev + priceVa;
          });
          console.log("RS + " + c.reason + " " + c.name) + "-" + amountVa.toString();
          break;
        case "1":
          setAmountPe(function (prev) {
            return prev + pricePe;
          });
          console.log("RS - " + c.reason + " " + c.name) + "-" + amountPe.toString();
          break;
        case "2":
          setAmountPt(function (prev) {
            return prev + pricePt;
          });
          console.log("RS - " + c.reason + " " + c.name) + "-" + amountPt.toString();
          break;
        case "3":
          setAmountJour(function (prev) {
            return prev + priceJour;
          });
          console.log("RS - " + c.reason + " " + c.name) + "-" + amountJour.toString();
          break;
      }
    });
    if (amountVa > 0) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: 1,
          label: "VISITES ANNUELLES",
          price: priceVa.toLocaleString("Fr"),
          quantity: (amountVa / 3500000).toLocaleString("Fr"),
          s_total: amountVa.toLocaleString("Fr")
        }]);
      });
    }
    if (amountVa > 0) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: 2,
          label: "VISITE PREAMBAUCHE",
          price: pricePe,
          quantity: (amountPe / pricePe).toLocaleString("Fr"),
          s_total: amountPe.toLocaleString("Fr")
        }]);
      });
    }
    if (amountVa > 0) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: 3,
          label: "PERMIS DE TRAVAIL",
          price: pricePt,
          quantity: (amountPt / pricePt).toLocaleString("Fr"),
          s_total: amountPt.toLocaleString("Fr")
        }]);
      });
    }
    if (amountVa > 0) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: 4,
          label: "TRAVAILLEURS JOURNALIERS",
          price: priceJour,
          quantity: (amountJour / priceJour).toLocaleString("Fr"),
          s_total: amountJour.toLocaleString("Fr")
        }]);
      });
    }
  }, [customers, company]);
  return /*#__PURE__*/_jsxs(Container, {
    ref: ref,
    id: "printable",
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 6,
        children: /*#__PURE__*/_jsx(Image, {
          preview: false,
          src: "/drawables/emgl.png",
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 16,
        offset: 2,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx("b", {
              children: "MEDVIE SARLU"
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              color: "#C00000"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "Soici\xE9t\xE9 de prestations medicale"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("b", {
              children: " (+ 224) 620 14 95 56 ; Email : info@centremedvie.com"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        border: "4px solid #FBB03C"
      }
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 7,
        offset: 17,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: "10px",
            fontSize: "20px"
          },
          children: ["Conakry, le ", /*#__PURE__*/_jsx(Moment, {
            format: "DD/MM/YYYY"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 7,
        children: /*#__PURE__*/_jsx("h3", {})
      }), /*#__PURE__*/_jsx(Col, {
        span: 15,
        offset: 2,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "10px",
            background: "#666666"
          },
          children: company != null && /*#__PURE__*/_jsx("h3", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx("b", {
              style: {
                color: "#FFF"
              },
              children: company.label
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        span: 20,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
          dataSource: itemsAr,
          columns: cols,
          pagination: false,
          bordered: true
        })]
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        span: 17,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h4", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "TOTAL :"
          }), " ", (amountVa + amountPe, amountJour + amountPt).toLocaleString("Fr"), " GNF"]
        })]
      }), /*#__PURE__*/_jsx(Col, {
        span: 7
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 24
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      style: {
        border: "1px solid #9C9898",
        padding: "7px"
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          span: 10,
          children: [/*#__PURE__*/_jsx("b", {
            children: "N\xB0 de Compte : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "7308054626"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "Paiement \xE0 l\u2019ordre de : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "MEDVIE"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "RIB : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "010001730805462680"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "Code Swift : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            }
          }), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Col, {
          span: 10,
          offset: 4,
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse : Commune de Ratoma, Kaporo Centre, N\xB0 Registre: GN.TCC..."
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      })]
    })]
  });
});
export default CreateInvoice;